import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { accentProposals } from '../data/atmosphere';
import { rgbChannels } from '../utils/color';
import type { Accent, Aliveness } from '../types/anna';
interface SpecSettings {
  accent: Accent;
  accentHex: string;
  aliveness: Aliveness;
  reducedMotion: boolean;
  setReducedMotion: (value: boolean) => void;
  soundOn: boolean;
  setSoundOn: (value: boolean) => void;
}
const SpecSettingsContext = createContext<SpecSettings | null>(null);
export function SpecSettingsProvider({
  accent,
  aliveness = 'lively',
  children
}: {
  accent: Accent;
  aliveness?: Aliveness;
  children: React.ReactNode;
}) {
  const [reducedMotion, setReducedMotion] = useState(false);
  const [soundOn, setSoundOn] = useState(true);
  const accentHex = accentProposals.find(a => a.id === accent)?.hex ?? '#4FE3D0';

  // Also expose the accent on :root so portalled layers (Waarom?, sheets) pick it up.
  useEffect(() => {
    document.documentElement.style.setProperty('--accent', rgbChannels(accentHex));
  }, [accentHex]);
  const value = useMemo(() => ({
    accent,
    accentHex,
    aliveness,
    reducedMotion,
    setReducedMotion,
    soundOn,
    setSoundOn
  }), [accent, accentHex, aliveness, reducedMotion, soundOn]);
  return <SpecSettingsContext.Provider value={value} data-id="element-1793" data-mp="18vw6a77c3vcw">
      <div className="min-h-full w-full" style={{
      ['--accent' as string]: rgbChannels(accentHex)
    } as React.CSSProperties} data-id="element-1794" data-mp="18v4llrf9zi1e">
        {children}
      </div>
    </SpecSettingsContext.Provider>;
}
export function useSpecSettings(): SpecSettings {
  const ctx = useContext(SpecSettingsContext);
  if (!ctx) throw new Error('useSpecSettings moet binnen SpecSettingsProvider staan');
  return ctx;
}